import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/dist/query/react";

import { API_ENDPOINT } from "../../config";
import { File as ContentFile } from "../../interfaces";
import { toastMessage } from "../../utils/toastError";

export const fileApi = createApi({
  reducerPath: "fileApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_ENDPOINT + "/file",
    credentials: "include",
  }),
  endpoints: (build) => ({
    uploadFile: build.mutation<{ file: ContentFile; message: string }, File>({
      query: (body) => {
        const formData = new FormData();
        formData.append("file", body);
        return {
          url: "/",
          method: "POST",
          body: formData,
        };
      },
      transformErrorResponse(baseQueryReturnValue) {
        toastMessage("error", baseQueryReturnValue.data);
        return Promise.reject(baseQueryReturnValue.data);
      },
      transformResponse(baseQueryReturnValue: { file: ContentFile; message: string }) {
        // toastMessage("success", "Successfully uploaded file");
        return baseQueryReturnValue;
      },
    }),
  }),
});

export const { useUploadFileMutation } = fileApi;
